<p *ngIf="position > 0" class="text-center text-3xl" i18n>You are {{ position }} in the queue!</p>

<div class="progress-holder">
  <div class="progressCircle">

    <svg class="svg" width="100%" viewPort="0 0 128 128" viewBox="0 0 256 256" version="1.1" xmlns="http://www.w3.org/2000/svg">

      <defs>
        <linearGradient id="linear2" x1="0" x2="1" y1="0" y2="0">
          <stop offset="0%"   stop-color="rgba(255,255,255,0)"/>
          <stop offset="30%"   stop-color="rgba(255,255,255,0)"/>
          <stop offset="100%" stop-color="rgba(255,255,255,0.9)"/>
        </linearGradient>
      </defs>

      <mask id="mask" x="0" y="0" width="100%" height="100%">
        <circle #loader_barmask id="barmask" r="98" cx="128" cy="128" fill="transparent" stroke-dasharray="615.752" stroke-dashoffset="615.752"></circle>
      </mask>

      <mask id="cmask" x="0" y="0" width="100%" height="100%">
        <circle id="circcmask" r="98" cx="128" cy="128" fill="#ff0" ></circle>
      </mask>

      <!-- background -->
      <circle id="bar-bg" r="98" cx="128" cy="128" fill="transparent" stroke-dasharray="615.752" stroke-dashoffset="615.752"></circle>

      <!-- percent fill -->
      <g >
        <circle #loader_bar id="bar" r="98" cx="128" cy="128" fill="transparent" stroke-dasharray="615.752" stroke-dashoffset="615.752"></circle>
      </g>

      <!-- percent fill anim flow -->
      <g mask="url(#mask)">
        <circle id="bar-anim" r="110" cx="128" cy="128"></circle>
      </g>

      <text x="128" y="128" dominant-baseline="middle" text-anchor="middle" class="percent"></text>

    </svg>
    <div #valueBox_percent class="percent">0%</div>

    <!--<span class="percent" #valueBox_percent>0%</span>-->
  </div>

  <div class="stage" id="stage" >
    <span #valueBox_stage></span>&nbsp;
  </div>

</div>
